import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './util/flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/icon/iconfont.css"; //svg引入js
import * as echarts from 'echarts'
import moment from 'moment';
Vue.prototype.$moment = moment;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
